var _defs, _rect, _text, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _circle, _path7, _path8, _path9, _path0, _path1, _rect3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect4, _line, _line2, _line3, _line4, _line5, _line6, _rect5, _circle2, _rect6, _rect7, _path18, _rect8, _polygon, _polygon2, _circle3, _circle4, _polygon3, _circle5, _circle6, _circle7, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileappdevelopment6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d8c4df;}.cls-2{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-2,.cls-3{fill:#2f2143;}.cls-4{fill:#9a499c;}.cls-5{fill:#e3dfe5;}.cls-6{fill:#ffc636;}.cls-7{fill:#ffc436;}.cls-8{fill:#321f46;}.cls-9{fill:#faab77;}.cls-10{fill:#6b7bbc;}.cls-11{fill:#2f2243;}.cls-12{fill:#1e3966;}.cls-13{fill:#fff;}.cls-14,.cls-15,.cls-16,.cls-17{fill:none;stroke-miterlimit:10;}.cls-14{stroke:#fff;stroke-width:0.75px;}.cls-15,.cls-17{stroke:#2f2143;}.cls-15{stroke-width:5.96px;}.cls-16{stroke:#9a499c;}.cls-16,.cls-17{stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MOBILE APP DEVELOPMENT 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1600,
    height: 326
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(672.96 152.15)"
  }, "MOBILE ", /*#__PURE__*/React.createElement("tspan", {
    x: -180.61,
    y: 75
  }, "APP DEVELOPMENT"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M393.29,302.09H261.58a16.39,16.39,0,0,1-16.39-16.39V39.76a16.38,16.38,0,0,1,16.39-16.38H393.29a16.38,16.38,0,0,1,16.39,16.38V285.7a16.39,16.39,0,0,1-16.39,16.39",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M385.54,284.11H269.32a14.53,14.53,0,0,1-14.53-14.54V50.33a14.53,14.53,0,0,1,14.53-14.54H385.54a14.54,14.54,0,0,1,14.54,14.54V269.57a14.54,14.54,0,0,1-14.54,14.54",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M254.79,70.83H315a12.48,12.48,0,0,1,12.48,12.48v40.39A12.48,12.48,0,0,1,315,136.17H254.79a0,0,0,0,1,0,0V70.83A0,0,0,0,1,254.79,70.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M360.17,213H374.8a15.55,15.55,0,0,1,15.55,15.55v0a15.55,15.55,0,0,1-15.55,15.55h-3.3a15.76,15.76,0,0,1-15.76-15.76v-10.9a4.44,4.44,0,0,1,4.44-4.44Z",
    transform: "translate(746.08 457.04) rotate(-180)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M344,46.45H311.52a2.63,2.63,0,0,1,0-5.25H344a2.63,2.63,0,0,1,0,5.25",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M338.4,271.31a11,11,0,1,1-11-11,11,11,0,0,1,11,11",
    transform: "translate(0 0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 217.33,
    y: 217.96,
    width: 55.17,
    height: 21.13,
    rx: 9.98,
    transform: "translate(489.83 457.04) rotate(-180)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 227.89,
    cy: 228.52,
    r: 10.57
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M122,309.78s-5.91-.29-7.66-2.93-4.71-29.27-.65-43.2c0,0,7.41-20.68,5.3-26.83l-2.16-49.07L153,184.49s-6.74,45.56-10.21,51.64C142.75,236.13,125,305.74,122,309.78Z",
    transform: "translate(0 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M163.94,308.22s-17.84-29.05-19.58-45.73c0,0-1-12.83-.2-20.21l-10-57.18H166s3.39,24.32.87,43.74-3,24.59-2.94,27.67,4.46,39.55,7.84,51.2A7,7,0,0,1,163.94,308.22Z",
    transform: "translate(0 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M159.23,193.2s-1.85,4.7-3.11,6.11-30.7,4.08-46.26-8.69c0,0,10.63-65,24.69-87.57,0,0,3.37-5.07,16.78-4.87,0,0,0-1.39,3.18-1.85l7.24,18.12s7.13-12.88,6.67-13.71,2.28,2,2.37,3.93a79,79,0,0,1,7,3.72c.89.77,2.35-.16,7.75,15.68s10.53,21.18,10.53,21.18l-2.18,16.25L179.6,150l-4.49-5.79-3.83,51.49-10.83,2.81-1-5.71",
    transform: "translate(0 0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M161.77,115l-7.24-19.12s4.66-7.64,4.88-12.32l11.79,6s-2.62,8.74-2.71,10.63C168.49,100.19,165.73,109.84,161.77,115Z",
    transform: "translate(0 0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M158.5,74.89s-1.73,4.47-.66,6.77,2.81,6.33,10.77,8.64c0,0,3.56,2.12,5.32-1.09,0,0,4.18-5.76,5.14-10,0,0,1.22-13.33-1.88-13.82s-18,6.53-18.69,7.59A1.73,1.73,0,0,0,158.5,74.89Z",
    transform: "translate(0 0)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 193.98,
    y: 143.91,
    width: 85.24,
    height: 32.09,
    rx: 5.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M179.23,78.61s-1.36-.12-.81-8.37a7.71,7.71,0,0,0-2.2-4.91s-6.38,11.56-15,12.71a35.65,35.65,0,0,0,8.08-6A12.09,12.09,0,0,1,158.66,74s-1.36,4.15-.66,7.12L157.48,83s-.88-3.32-2.63-3.29a3.3,3.3,0,0,1-3.78-1.48s-2.66-2.72-2.29-8.53A19.57,19.57,0,0,1,152,60.44a6.49,6.49,0,0,1-2.42,0s-2-.54-3.19-6.13c0,0-1.1-3.86,3-8.53,0,0,2.26-3.11,8.13,1.09,0,0-.9-2.48-6.3-3,0,0,10.43-.26,11.46,8.22,0,0,8.24-5.48,17.49,12.21C180.23,64.25,185.76,69.12,179.23,78.61Z",
    transform: "translate(0 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M159.28,167.05s16.19,5.11,23.17,6c0,0,8.71,2.33,11.4,3.46s12.13-.32,11.69-7.26c0,0-.75-.78-4.66-.55,0,0-4.61-.24-5.08-.8,0,0,3.88-.21,4-.61,0,0,1.41-.45.7-1.35,0,0-.95-.56-7.72.16l-9.32.27-19.49-11.74Z",
    transform: "translate(0 0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M162.51,320.87s-.84-5.38.77-7.29c0,0,2.17-2.44-.2-6.27,0,0,5,1.81,8.63-.56,0,0,6.56,7.66,7.75,8.15,0,0,10.6,1.34,10.25,6Z",
    transform: "translate(0 0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M112.74,321.37s-.84-5.38.77-7.29c0,0,2.49-5.34.13-9.16,0,0,5.46,5.63,9.1,3.26,0,0,5.76,6.73,7,7.22,0,0,10.6,1.34,10.25,6Z",
    transform: "translate(0 0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M198.54,153.75c5.34-.15,10.68-.22,16-.28l16-.09,16,.09c5.34.06,10.68.13,16,.28-5.34.16-10.68.23-16,.29l-16,.09-16-.09C209.22,154,203.88,153.91,198.54,153.75Z",
    transform: "translate(0 0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M198.54,159.62c4.83-.15,9.66-.22,14.48-.28l14.48-.09,14.48.08c4.82.06,9.65.14,14.48.29-4.83.16-9.66.23-14.48.29L227.5,160,213,159.91C208.2,159.85,203.37,159.78,198.54,159.62Z",
    transform: "translate(0 0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M198.54,164.35c4.45-.16,8.89-.23,13.33-.29L225.2,164l13.33.09c4.44.06,8.89.13,13.33.29-4.44.15-8.89.23-13.33.29l-13.33.08-13.33-.09C207.43,164.57,203,164.5,198.54,164.35Z",
    transform: "translate(0 0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M205.46,169.07c2.93-.15,5.87-.22,8.81-.28s5.87-.06,8.81-.09,5.88,0,8.81.08,5.88.14,8.82.29c-2.94.16-5.88.23-8.82.29s-5.87.06-8.81.09-5.87,0-8.81-.09S208.39,169.23,205.46,169.07Z",
    transform: "translate(0 0)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 260.96,
    y: 160.29,
    width: 11.54,
    height: 9.83
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 335.37,
    y1: 71.96,
    x2: 390.35,
    y2: 71.96
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 335.37,
    y1: 84.48,
    x2: 390.35,
    y2: 84.48
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 335.37,
    y1: 97,
    x2: 390.35,
    y2: 97
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 335.37,
    y1: 109.52,
    x2: 390.35,
    y2: 109.52
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 335.37,
    y1: 122.04,
    x2: 390.35,
    y2: 122.04
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 335.37,
    y1: 134.57,
    x2: 390.35,
    y2: 134.57
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 385.78,
    y: 103.3,
    width: 55.17,
    height: 21.13,
    rx: 9.98
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 430.39,
    cy: 113.87,
    r: 10.57
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.39,
    y: 184.49,
    width: 135.78,
    height: 3.33,
    rx: 1.67
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.39,
    y: 198.88,
    width: 135.78,
    height: 3.33,
    rx: 1.67
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1246.13,62.86a27.58,27.58,0,0,0-4,9.61l-5.37.5V83.36l5.37.51a27.66,27.66,0,0,0,4,9.61l-3.43,4.14,7.35,7.34,4.14-3.42a27.77,27.77,0,0,0,9.61,4l.5,5.37h10.39l.51-5.37a27.85,27.85,0,0,0,9.61-4l4.13,3.42,7.35-7.34-3.42-4.14a27.85,27.85,0,0,0,4-9.61l5.36-.51V73l-5.37-.5a27.6,27.6,0,0,0-4-9.61l3.43-4.14-7.35-7.35-4.13,3.43a27.66,27.66,0,0,0-9.61-4l-.51-5.37H1264.3l-.5,5.37a27.58,27.58,0,0,0-9.61,4l-4.14-3.43-7.35,7.35Zm33.31,5.36a14.06,14.06,0,1,1-19.89,0,14.05,14.05,0,0,1,19.89,0",
    transform: "translate(0 0)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1222.95,
    y: 229.18,
    width: 50.2,
    height: 46.78
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1225.95 275.96 1240.47 252.11 1253.75 275.96 1225.95 275.96"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1245.35 275.96 1259.87 239.24 1273.14 275.96 1245.35 275.96"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1233.06,
    cy: 236.08,
    r: 3.89
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1508.83,
    cy: 90.99,
    r: 31.96
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1526.24 90.99 1497.73 74.52 1497.73 107.45 1526.24 90.99"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 998.37,
    cy: 65.35,
    r: 19.03
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 1444.9,
    cy: 247.14,
    r: 19.03
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 534.57,
    cy: 73.91,
    r: 10.96
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M535.22,119A23,23,0,1,1,574.4,95.09",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileappdevelopment6);
export default __webpack_public_path__ + "static/media/MOBILE APP DEVELOPMENT 6.a3b17b8ab88031c035c2dde4acaf081f.svg";
export { ForwardRef as ReactComponent };